export const messages = {
  en: {
    editOwnerCommittee: {
      title: 'Edit Owner Committee',
      name: 'Name',
      nameRequired: 'Name is required',
      namePlaceholder: 'Please enter name',
      sex: 'Gender',
      sexRequired: 'Gender is required',
      sexPlaceholder: 'Please select gender',
      male: 'Male',
      female: 'Female',
      phone: 'Phone',
      phoneRequired: 'Phone is required',
      phoneLength: 'Phone must be 11 digits',
      phonePlaceholder: 'Please enter phone number',
      idCard: 'ID Card',
      idCardRequired: 'ID Card is required',
      idCardLength: 'ID Card must be 18 digits',
      idCardPlaceholder: 'Please enter ID card number',
      address: 'Address',
      addressRequired: 'Address is required',
      addressMaxLength: 'Address cannot exceed 256 characters',
      addressPlaceholder: 'Please enter address',
      position: 'Position',
      positionRequired: 'Position is required',
      positionMaxLength: 'Position cannot exceed 64 characters',
      positionPlaceholder: 'Please enter position',
      post: 'Post',
      postRequired: 'Post is required',
      postMaxLength: 'Post cannot exceed 64 characters',
      postPlaceholder: 'Please enter post',
      postDesc: 'Post Description',
      postDescMaxLength: 'Description cannot exceed 64 characters',
      postDescPlaceholder: 'Optional, enter description',
      appointTime: 'Term',
      appointTimeRequired: 'Term is required',
      appointTimeMaxLength: 'Term cannot exceed 256 characters',
      appointTimePlaceholder: 'Please enter term',
      curTime: 'Tenure',
      curTimeRequired: 'Tenure is required',
      curTimeMaxLength: 'Tenure cannot exceed 256 characters',
      curTimePlaceholder: 'Please enter tenure',
      status: 'Status',
      statusRequired: 'Status is required',
      statusPlaceholder: 'Please select status',
      onDuty: 'On Duty',
      leave: 'Leave',
      remark: 'Remark',
      remarkMaxLength: 'Remark cannot exceed 200 characters',
      remarkPlaceholder: 'Optional, enter remark',
      emergencyContact: 'Emergency Contact',
      relation: 'Relationship',
      relationPlaceholder: 'Required, enter relationship',
      contactName: 'Contact Name',
      contactNamePlaceholder: 'Required, enter name',
      contactPhone: 'Contact Phone',
      contactPhonePlaceholder: 'Required, enter phone',
      contactAddress: 'Contact Address',
      contactAddressPlaceholder: 'Required, enter address',
      updateSuccess: 'Update successful',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    editOwnerCommittee: {
      title: '修改业委会',
      name: '姓名',
      nameRequired: '姓名不能为空',
      namePlaceholder: '请填写姓名',
      sex: '性别',
      sexRequired: '性别不能为空',
      sexPlaceholder: '请选择性别',
      male: '男',
      female: '女',
      phone: '电话',
      phoneRequired: '电话不能为空',
      phoneLength: '电话必须为11位',
      phonePlaceholder: '请填写电话',
      idCard: '身份证号码',
      idCardRequired: '身份证号码不能为空',
      idCardLength: '身份证号码必须为18位',
      idCardPlaceholder: '请填写身份证号码',
      address: '住址',
      addressRequired: '住址不能为空',
      addressMaxLength: '住址不能超过256个字符',
      addressPlaceholder: '请填写住址',
      position: '职位',
      positionRequired: '职位不能为空',
      positionMaxLength: '职位不能超过64个字符',
      positionPlaceholder: '请填写职位',
      post: '岗位',
      postRequired: '岗位不能为空',
      postMaxLength: '岗位不能超过64个字符',
      postPlaceholder: '请填写岗位',
      postDesc: '岗位描述',
      postDescMaxLength: '描述不能超过64个字符',
      postDescPlaceholder: '选填，请填写岗位描述',
      appointTime: '届期',
      appointTimeRequired: '届期不能为空',
      appointTimeMaxLength: '届期不能超过256个字符',
      appointTimePlaceholder: '请填写届期',
      curTime: '任期',
      curTimeRequired: '任期不能为空',
      curTimeMaxLength: '任期不能超过256个字符',
      curTimePlaceholder: '请填写任期',
      status: '状态',
      statusRequired: '状态不能为空',
      statusPlaceholder: '请选择状态',
      onDuty: '在职',
      leave: '离职',
      remark: '备注',
      remarkMaxLength: '备注不能超过200个字符',
      remarkPlaceholder: '选填，请填写备注',
      emergencyContact: '紧急联系人',
      relation: '成员关系',
      relationPlaceholder: '必填，请填写关系',
      contactName: '姓名',
      contactNamePlaceholder: '必填，请填写名称',
      contactPhone: '联系电话',
      contactPhonePlaceholder: '必填，请填写电话',
      contactAddress: '住址',
      contactAddressPlaceholder: '必填，请填写地址',
      updateSuccess: '修改成功',
fetchError: '获取数据失败'
    }
  },
  'zh-TW': {
    editOwnerCommittee: {
      title: '修改業委會',
      name: '姓名',
      nameRequired: '姓名不能為空',
      namePlaceholder: '請填寫姓名',
      sex: '性別',
      sexRequired: '性別不能為空',
      sexPlaceholder: '請選擇性別',
      male: '男',
      female: '女',
      phone: '電話',
      phoneRequired: '電話不能為空',
      phoneLength: '電話必須為11位',
      phonePlaceholder: '請填寫電話',
      idCard: '身份證號碼',
      idCardRequired: '身份證號碼不能為空',
      idCardLength: '身份證號碼必須為18位',
      idCardPlaceholder: '請填寫身份證號碼',
      address: '住址',
      addressRequired: '住址不能為空',
      addressMaxLength: '住址不能超過256個字符',
      addressPlaceholder: '請填寫住址',
      position: '職位',
      positionRequired: '職位不能為空',
      positionMaxLength: '職位不能超過64個字符',
      positionPlaceholder: '請填寫職位',
      post: '崗位',
      postRequired: '崗位不能為空',
      postMaxLength: '崗位不能超過64個字符',
      postPlaceholder: '請填寫崗位',
      postDesc: '崗位描述',
      postDescMaxLength: '描述不能超過64個字符',
      postDescPlaceholder: '選填，請填寫崗位描述',
      appointTime: '屆期',
      appointTimeRequired: '屆期不能為空',
      appointTimeMaxLength: '屆期不能超過256個字符',
      appointTimePlaceholder: '請填寫屆期',
      curTime: '任期',
      curTimeRequired: '任期不能為空',
      curTimeMaxLength: '任期不能超過256個字符',
      curTimePlaceholder: '請填寫任期',
      status: '狀態',
      statusRequired: '狀態不能為空',
      statusPlaceholder: '請選擇狀態',
      onDuty: '在職',
      leave: '離職',
      remark: '備註',
      remarkMaxLength: '備註不能超過200個字符',
      remarkPlaceholder: '選填，請填寫備註',
      emergencyContact: '緊急聯繫人',
      relation: '成員關係',
      relationPlaceholder: '必填，請填寫關係',
      contactName: '姓名',
      contactNamePlaceholder: '必填，請填寫名稱',
      contactPhone: '聯繫電話',
      contactPhonePlaceholder: '必填，請填寫電話',
      contactAddress: '住址',
      contactAddressPlaceholder: '必填，請填寫地址',
      updateSuccess: '修改成功',
      fetchError: '獲取數據失敗'
    }
  }
}